import { HttpAccountsClient } from 'base/accounts_service';
import { AccountStore } from 'base/account_store';
import { injector } from 'base/dependency-container';
import { createHttpService } from './http';

export function createAccountService() {
  const http = injector.resolve(createHttpService);
  const service = new HttpAccountsClient(http);
  const store = new AccountStore(service);
  return {
    store,
    service,
  };
}
